


































import Vue from 'vue';
import { Data as HeadlinesData, DataWithHref } from '@root/modules/headlines/types/headlines';
import ArticleHeadline from './ArticleHeadline.vue';
import UniversalHeadlinesService from '@root/modules/headlines/services/UniversalHeadlines.service';
import getHeadlineWithHref from '@root/modules/headlines/utils/getHeadlineWithHref';
import getArticleUrl from '@root/modules/article/utils/buildArticleUrl';

interface Methods {
  addClickData: (headline: HeadlinesData, params: Record<string, any>) => Record<string, any>;
  getHeadline: (headline: HeadlinesData) => DataWithHref;
  getTopHeadlines: () => void;
  getArticleHeadlines: (relatedHeadlineIds: number[]) => Promise<HeadlinesData[]>;
}

interface Data {
  domains: string | string[];
  locale: string;
  language: string;
  topHeadlinesLimit: number;
  topHeadlines: HeadlinesData[];
  topHeadlinesList: number[];
}

export default Vue.extend<Data, Methods, unknown, unknown>({
  components: {
    ArticleHeadline,
  },
  data() {
    const { domain, locale, temporaryAllowedDomains, lang } = this.$channelConfig('settings');
    const domains = temporaryAllowedDomains ? [...new Set([...temporaryAllowedDomains, domain])] : domain;
    return {
      domains,
      locale,
      language: lang.toUpperCase(),
      topHeadlines: [],
      topHeadlinesLimit: 15,
      topHeadlinesList: this.$channelConfig('page').article.component.topHeadlines.topHeadlinesIds || [],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getTopHeadlines();
    });
  },
  methods: {
    addClickData(headline: HeadlinesData, params: Record<string, any>) {
      const clickData: Record<string, any> = {};

      clickData.articleLayout = 'a';
      clickData.listType = params.listType;
      clickData.listPosition = params.listPosition;
      clickData.listArticleId = headline.id;
      clickData.listArticleUrl = getArticleUrl({ article: headline, domain: headline.primaryCategory.channel.url });
      clickData.listArticlePosition = params.listIndex + 1;

      return { ...headline, clickData };
    },
    getHeadline(headline) {
      const fakeDomainEnabled = this.$config.FAKE_DOMAIN_ENABLED;
      return getHeadlineWithHref({ headline, domain: this.domains, fakeDomainEnabled });
    },
    async getTopHeadlines() {
      this.topHeadlines = this.topHeadlinesList ? await this.getArticleHeadlines(this.topHeadlinesList) : [];
    },
    async getArticleHeadlines(topHeadlineIds) {
      const universalHeadlinesService = new UniversalHeadlinesService();
      const headlines = await universalHeadlinesService.fetch({ id: topHeadlineIds, limit: this.topHeadlinesLimit });
      return headlines.items;
    },
  },
});
